<template>
  <div>
    <el-table
      :data="ingredients"
    >
      <el-table-column
        prop="ingredient"
        label="Név"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.ingredient.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="ingredient"
        label="Mennyiség"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.count }} db
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot-scope="scope"
        >
          <actions
            :ingredient="scope.row"
            @update="onUpdate"
            @delete="onDelete"
          />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible="showDialog"
      :title="ingredientFormType === 'add' ? 'Új összetevő' : 'Összetevő módosítás'"
      append-to-body
      :close-on-click-modal="false"
      width="550px"
      @close="onClose"
      :key="dialogKey"
    >
      <ingredient-form
        ref="ingredientForm"
        :defaultIngredient="selectedIngredient"
        :formType="ingredientFormType"
        :ingredients="ingredients"
      />
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="onClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          @click="storeIngredients"
        >
          {{ ingredientFormType === 'add' ? 'Hozzáadás' : 'Módosítás' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Actions from './Actions';
  import IngredientForm from './Form';

  export default {
    components: { Actions, IngredientForm },
    props: ['ingredients', 'showDialog', 'ingredientFormType'],
    data() {
      return {
        dialogKey: 0,
        selectedIngredient: {},
      };
    },
    methods: {
      onClose() {
        this.$refs.ingredientForm.currIngredient = {};
        this.$refs.ingredientForm.currIngredientId = 0;
        this.$emit('closeDialog');
        this.$refs.ingredientForm.$refs.ingredientForm.resetFields();
      },
      onCreate() {
        this.ingredientFormType = 'add';
        this.dialogKey++;
        this.$emit('openCreateDialog');
      },
      onUpdate(ingredient) {
        this.selectedIngredient = Object.assign({}, ingredient);
        this.$emit('openUpdateDialog');
      },
      onDelete(ingredient) {
        const ingredients = this.ingredients.filter(a => ((a.id && a.id !== ingredient.id) || a.key !== ingredient.key));
        this.$emit('change', ingredients);
      },
      async storeIngredients() {
        const ingredient = Object.assign({}, this.$refs.ingredientForm.currIngredient);
        this.$refs['ingredientForm'].$refs['ingredientForm'].validate(valid => {
          if (valid) {
            if (this.ingredientFormType === 'add') {
              this.$emit('add', ingredient);
            } else {
              const ingredients = this.ingredients.map(a => {
                if ((a.id && a.id === ingredient.id) || (a.key && a.key === ingredient.key)) {
                  return ingredient;
                } else {
                  return a;
                }
              });
              this.$emit('change', ingredients);
            }
            this.$emit('closeDialog');
          }
        });
      },
    }
  };
</script>
